/*
  RP — Lovense free-gift dialog (October 2026 promo). Added 2026-10-06.
  Markup + styles: snippets/rp-lovense-gift-dialog.liquid
  Rendered from sections/main-cart.liquid (cart page) and sections/cart-drawer.liquid (drawer).

  - Cart page: checks /cart.js once the page loads, and again whenever the theme
    changes the cart without a reload (its `cart:updated` event).
  - Drawer: does nothing until the drawer is opened, then checks /cart.js.
  - $50+ of Lovense (bundle excluded) and no bundle in the cart -> show the dialog,
    unless the shopper said "No thanks" earlier in this visit (sessionStorage).
  - Bundle in the cart but under $50 of Lovense -> show the inline notice.
*/
(function () {
  'use strict';

  // OFFER CUT-OFF — after this moment the script does nothing. (On Nov 1, delete this whole file.)
  var OFFER_ENDS = Date.parse('2026-10-31T23:59:00-04:00');
  if (!(Date.now() < OFFER_ENDS)) return;

  if (window.rpLovenseGiftLoaded) return;
  window.rpLovenseGiftLoaded = true;

  var BUNDLE_VARIANT_ID = 68011199103127;
  var THRESHOLD_CENTS = 5000;
  var VENDOR = 'lovense';
  var DISMISS_KEY = 'rpGiftDismissed';
  var GENERIC_ERROR = 'Sorry — we couldn’t update your cart. Please try again.';

  var dialog = document.querySelector('[data-rp-gift-dialog]');
  var notice = document.querySelector('[data-rp-gift-notice]');
  if (!dialog || !notice) return;

  var addBtn = dialog.querySelector('[data-rp-gift-add]');
  var dismissBtn = dialog.querySelector('[data-rp-gift-dismiss]');
  var dialogError = dialog.querySelector('[data-rp-gift-error]');
  var removeBtn = notice.querySelector('[data-rp-gift-remove]');
  var noticeError = notice.querySelector('[data-rp-gift-notice-error]');

  var drawer = dialog.closest('cart-drawer');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var addLabel = addBtn.textContent;
  var bundleKey = null;
  var lastFocus = null;
  var busy = false;
  var checkTimer = null;

  function isDismissed() {
    try { return window.sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; }
  }

  function rememberDismissed() {
    try { window.sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
  }

  function drawerIsOpen() {
    return !!drawer && drawer.hasAttribute('open');
  }

  function postJSON(path, payload) {
    return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok || data.status >= 400) {
          throw new Error(data.description || data.message || GENERIC_ERROR);
        }
        return data;
      });
    });
  }

  // Shows the new cart: the drawer re-renders itself via the theme's `cart:refresh`
  // event (handled in assets/cart.js); the cart page simply reloads.
  function showUpdatedCart() {
    if (drawer && window.FoxTheme) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    } else {
      window.location.reload();
    }
  }

  function scheduleCheck(delay) {
    window.clearTimeout(checkTimer);
    checkTimer = window.setTimeout(check, delay || 0);
  }

  function check() {
    if (busy || dialog.open) return;
    if (drawer && !drawerIsOpen()) return;

    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart.js ' + response.status);
        return response.json();
      })
      .then(evaluate)
      .catch(function () {
        // The offer is optional — if the cart can't be read, show nothing.
      });
  }

  function evaluate(cart) {
    var lovenseTotal = 0;
    bundleKey = null;

    (cart.items || []).forEach(function (item) {
      if (Number(item.variant_id) === BUNDLE_VARIANT_ID) {
        if (!bundleKey) bundleKey = item.key;
        return;
      }
      if (String(item.vendor || '').trim().toLowerCase() === VENDOR) {
        lovenseTotal += Number(item.original_line_price) || 0;
      }
    });

    var bundleInCart = bundleKey !== null;
    var qualifies = lovenseTotal >= THRESHOLD_CENTS;

    if (bundleInCart && !qualifies) {
      noticeError.hidden = true;
      notice.hidden = false;
    } else {
      notice.hidden = true;
    }

    if (qualifies && !bundleInCart && !isDismissed()) {
      openDialog();
    }
  }

  function openDialog() {
    if (dialog.open || typeof dialog.showModal !== 'function') return;
    if (drawer && !drawerIsOpen()) return;

    dialogError.hidden = true;
    dialogError.textContent = '';
    setBusy(false);
    lastFocus = document.activeElement;
    dialog.showModal();
    addBtn.focus();
  }

  function closeDialog() {
    if (!dialog.open) return;
    dialog.close();
    if (lastFocus && lastFocus.isConnected && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
    lastFocus = null;
  }

  function dismiss() {
    if (busy) return;
    rememberDismissed();
    closeDialog();
  }

  function setBusy(state) {
    busy = state;
    addBtn.disabled = state;
    dismissBtn.disabled = state;
    addBtn.textContent = state ? 'Adding…' : addLabel;
    dialog.setAttribute('aria-busy', state ? 'true' : 'false');
  }

  addBtn.addEventListener('click', function () {
    if (busy) return;
    dialogError.hidden = true;
    setBusy(true);

    postJSON('cart/add.js', { items: [{ id: BUNDLE_VARIANT_ID, quantity: 1 }] })
      .then(function () {
        setBusy(false);
        closeDialog();
        showUpdatedCart();
      })
      .catch(function (error) {
        setBusy(false);
        dialogError.textContent = error && error.message ? error.message : GENERIC_ERROR;
        dialogError.hidden = false;
        addBtn.focus();
      });
  });

  dismissBtn.addEventListener('click', dismiss);

  // Escape: the browser fires `cancel` on the dialog. We close it ourselves (same as
  // "No thanks"), then swallow the matching keyup so the theme's drawer — which also
  // closes on Escape keyup (assets/theme.js ModalComponent) — stays open.
  dialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    if (busy) return;
    dismiss();
    window.addEventListener('keyup', function swallowEscape(keyEvent) {
      if (keyEvent.key === 'Escape' || keyEvent.code === 'Escape') {
        keyEvent.stopImmediatePropagation();
      }
      window.removeEventListener('keyup', swallowEscape, true);
    }, true);
  });

  // Backdrop click = the click lands on the <dialog> itself, outside the inner panel.
  // Only counts if the press also started on the backdrop (not a text-selection drag).
  var pressStartedOnBackdrop = false;
  dialog.addEventListener('pointerdown', function (event) {
    pressStartedOnBackdrop = event.target === dialog;
  });
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog && pressStartedOnBackdrop) dismiss();
    pressStartedOnBackdrop = false;
  });

  removeBtn.addEventListener('click', function () {
    if (!bundleKey || removeBtn.disabled) return;
    removeBtn.disabled = true;
    noticeError.hidden = true;

    postJSON('cart/change.js', { id: bundleKey, quantity: 0 })
      .then(function () {
        removeBtn.disabled = false;
        notice.hidden = true;
        showUpdatedCart();
      })
      .catch(function (error) {
        removeBtn.disabled = false;
        noticeError.textContent = error && error.message ? error.message : GENERIC_ERROR;
        noticeError.hidden = false;
      });
  });

  // The theme fires `cart:updated` after it changes the cart without a page reload
  // (quantity changes, removals, drawer refresh — assets/cart.js CartItems).
  document.addEventListener('cart:updated', function () {
    scheduleCheck(150);
  });

  if (drawer) {
    // The drawer is <cart-drawer open> while showing. Check once it has slid in.
    new MutationObserver(function () {
      if (drawerIsOpen()) {
        scheduleCheck(400);
      } else {
        closeDialog();
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    if (drawerIsOpen()) scheduleCheck(0);
  } else {
    scheduleCheck(0);
  }
})();
